// PublicHeader.js

import React from 'react';
import '../App.css';
import Logo from '../assets/EveryID.png';
import { useBranding } from '../contexts/BrandingContext';
import { useNavigate } from 'react-router-dom';

export default function PublicHeader() {

  const { branding, loading } = useBranding();
  const navigate = useNavigate();

  // Prevent logo flash while branding loads
  if (loading) {
    return (
      <header
        className="public-header"
        style={{
          height: 90
        }}
      />
    );
  }

  return (

    <header className="public-header">

      <img
        src={
          branding?.loginLogoUrl ||
          Logo
        }
        alt={
          branding?.brandName ||
          'EveryID'
        }
        onClick={() =>
          navigate('/homepage')
        }
        style={{
          cursor: 'pointer',
          height: 70,
          objectFit: 'contain'
        }}
      />

    </header>

  );

}
